
















































































































































































































































































































































































































































































































































































import { Component, Vue, Watch, Mixins } from 'vue-property-decorator'
import TaskApi from '@/api/task'
import PageLayout from '@/components/page/PageLayout.vue'
import ActionCol from './actionCol.vue'
import { TOKEN } from '@/store/mutation-types'
import isEmpty from 'lodash/isEmpty'
import cloneDeep from 'lodash/cloneDeep'
import { columns } from './config'
import listMixins from '@/mixins/list'
import { download } from '@/utils/util'
import { YI_WAN_CHENG, YI_QU_XIAO, YI_GUAN_DAN } from '@/web-task/config'
import { filterColumnsByPermission } from '@/utils/helper/permission'
const EXPORT_QUERY_INTERVAL = 2000

@Component({
	name: 'AiiTasksList',
	components: {
		PageLayout,
		ActionCol,
	},
})
export default class TasksList extends Mixins(listMixins) {
	private columns: object = filterColumnsByPermission(columns)
	private data: any[] = []
	private visible: boolean = false
	private YI_WAN_CHENG = YI_WAN_CHENG
	private YI_QU_XIAO = YI_QU_XIAO
	private YI_GUAN_DAN = YI_GUAN_DAN

	private timer: any = ''
	private fileTimer: any = ''
	private exportingList: boolean = false
	private exportingTask: boolean = false

	private get taskAuthObj() {
		return {
			cancelAudit: this.$auth('taskDetail:auditCancelTask'),
			audit: this.$auth('taskDetail:auditTask'),
			resend: this.$auth('taskList:resend'),
		}
	}

	private get commonStatusMap(): any {
		return Object.assign(
			{},
			this.$store.state.setting.orderStatusMap,
			this.$store.state.setting.conOrderStatusMap
		)
	}

	private goToDetail(action: any) {
		return `/AiiTasks/TasksDetail/${action.orderId}/${action.taskType}`
	}

	public getList() {
		return TaskApi.getCommonTaskList(this.getForm()).then((res: any) => {
			this.data = res.data.retList
			this.total = res.data.count
			this.resetSelected()
		})
	}

	public activated() {
		this.$store.dispatch('setting/initCompanyTree').then((res: any) => {
			this.setCompanyAsTree()
		})
		this.$store.dispatch('setting/initAreas').then((res: any) => {
			this.setAreaAsTree()
		})
		this.getList()
		this.timer = setInterval(() => {
			if (Vue.ls.get(TOKEN)) {
				this.$ss.set('expandTime', 1)
				this.getList().finally(() => {
					this.$ss.remove('expandTime')
				})
			}
		}, 5 * 60 * 1000)
	}

	private addTask() {
		this.$router.push('/AiiTasks/addTask')
	}

	private deactivated() {
		clearInterval(this.timer)
	}

	private beforeDestroy() {
		this.fileTimer && clearInterval(this.fileTimer)
	}

	private onTaskAdd() {
		this.resetPage()
		this.getList()
	}

	private getForm() {
		const form: any = this.getSearchValues()
		form.createTime =
			form.startendTime &&
			form.startendTime[0] &&
			form.startendTime[0].format('YYYY-MM-DD')
		form.endTime =
			form.startendTime &&
			form.startendTime[1] &&
			form.startendTime[1].format('YYYY-MM-DD')
		if (form.finishTime) {
			form.finishStartTime =
				form.finishTime &&
				form.finishTime[0] &&
				form.finishTime[0].format('YYYY-MM-DD')
			form.finishEndTime =
				form.finishTime &&
				form.finishTime[1] &&
				form.finishTime[1].format('YYYY-MM-DD')
			delete form.finishTime
		}

		delete form.startendTime

		let temp =
			typeof form.company.value === 'string'
				? form.company.value.trim()
				: form.company.value
		if (temp || temp === 0) {
			form.companyId = temp
		}
		delete form.company

		return form
	}

	private canAudit(action: any) {
		return action.orderStatus === '04' && this.$auth('taskDetail:auditTask')
	}

	private exportDownloadPoll(fileId: string) {
		TaskApi.exportDownload(fileId)
			.then((file: any) => {
				if (file.filename) {
					download(file.data, file.filename)
					this.exportingList = false
				}
			})
			.catch((err: any) => {
				if (err.code === 200) {
					this.fileTimer = setTimeout(() => {
						this.exportDownloadPoll(fileId)
					}, EXPORT_QUERY_INTERVAL)
					return
				}
				console.error('exportDownload err: ', err)
				this.exportingList = false
			})
	}

	private async exportList() {
		this.exportingList = true
		let fileId: string = ''
		try {
			let res: any = await TaskApi.getExportFileId(this.getForm())
			fileId = res.data
			this.exportDownloadPoll(fileId)
		} catch (err) {
			console.error('getExportFileId failed: ', err)
			this.exportingList = false
		}
	}

	private exportOrder() {
		if (this.checkSelected()) {
			const selected = this.selected
			if (selected.length > 10) {
				return this.$message.error('最多选择10个订单')
			}
			const orderIds = selected.map((item: any) => item.orderId)
			this.exportingTask = true
			TaskApi.batchExport(orderIds)
				.then((res: any) => {
					const blob: any = new Blob([res.data])
					download(blob, res.filename)
				})
				.finally(() => {
					this.exportingTask = false
				})
		}
	}

	private checkSelected() {
		if (!this.selected.length) {
			this.$message.error('请选择订单')
			return false
		}
		return true
	}
}
